/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JoinLadderBody
 */
export interface JoinLadderBody {
    /**
     * 
     * @type {string}
     * @memberof JoinLadderBody
     */
    teamId?: string;
}

/**
 * Check if a given object implements the JoinLadderBody interface.
 */
export function instanceOfJoinLadderBody(value: object): value is JoinLadderBody {
    return true;
}

export function JoinLadderBodyFromJSON(json: any): JoinLadderBody {
    return JoinLadderBodyFromJSONTyped(json, false);
}

export function JoinLadderBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): JoinLadderBody {
    if (json == null) {
        return json;
    }
    return {
        
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
    };
}

export function JoinLadderBodyToJSON(json: any): JoinLadderBody {
    return JoinLadderBodyToJSONTyped(json, false);
}

export function JoinLadderBodyToJSONTyped(value?: JoinLadderBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teamId': value['teamId'],
    };
}

